import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 10%;
  justify-content: left;
  width: 80%;
  max-width: 80%;
  max-height: 90%;

  img {
    max-width: 30%;
    height: auto;
    border-radius: 50%;
  }

  @media only screen and (max-width: 600px) {
    justify-content: start;
    align-items: center;
    flex-direction: column;
    gap: 5%;
    height: 90%;
    width: 90%;
    max-width: 90%;

    img {
      width: auto;
      max-width: 80%;
      max-height: 30%;
    }
  }
`;

export const ContactLinks = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5%;

  @media only screen and (max-width: 600px) {
    justify-content: start;
    align-items: center;
    height: 100%;
  }
`;

export const ContactLink = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;

  a {
    color: ${({ theme }) => theme.colours.fg};
    text-decoration: underline 0.1rem rgba(0, 0, 0, 0);
    text-underline-offset: 0.1em;
    transition:
      text-decoration-color 150ms,
      text-underline-offset 150ms,
      color 150ms;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colours.accent};
      text-decoration-color: ${({ theme }) => theme.colours.accent};
      text-underline-offset: 0.3em;
    }

    @media (hover: none) {
      text-decoration: underline 0.1rem ${({ theme }) => theme.colours.accent};
    }
  }
`;
